'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stateFromBrowser = exports.defaultInitState = undefined;

var _flow2 = require('lodash/flow');

var _flow3 = _interopRequireDefault(_flow2);

exports.newReducer = newReducer;
exports.default = getInitState;

var _actions = require('./actions');

var _reducer = require('./reducer');

var _reducer2 = _interopRequireDefault(_reducer);

var _selectors = require('./selectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function newReducer(action) {
  return (0, _reducer2.default)(undefined, action);
}
// defaultInitState(location, title)
var defaultInitState = exports.defaultInitState = (0, _flow3.default)(_actions.create, newReducer);
var stateFromBrowser = exports.stateFromBrowser = (0, _flow3.default)(_actions.createFromBrowser, newReducer);

function getInitState(location, title, history) {
  if ((0, _selectors.browserHasHistory)(history)) return stateFromBrowser(history.state);
  return defaultInitState(location, title);
}


//////////////////
// WEBPACK FOOTER
// ./~/redux-history-sync/lib/initState.js
// module id = 1296
// module chunks = 0